'use strict';
import React, { PureComponent } from 'react';
import InputFecha from '../../Common/InputFecha';

class SeccionSuperior extends PureComponent {
    constructor(props) {
        super(props);

        this.cambiarOpcionCombo = this.cambiarOpcionCombo.bind(this);
    }

    cambiarOpcionCombo(nombreCombo, valorCombo) {
        this.props.onEstadoModificado(nombreCombo, valorCombo);
        this.props.obtenerDetallesModelo(valorCombo);
    }

    render() {
        const { modelosManuales, selectorFechaNuevoAsiento, validarSelectorFecha, comboModeloNuevoAsiento} = this.props;

        return (
            <div className="AsientosContables--overflowHidden">
                <div className="AsientosContables--floatLeft">
                    <div className="seccionDatosGenerales__tituloSecundario">Modelo</div>
                    <div>
                        <select 
                            name="modeloSelect" 
                            className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect_nuevoAsiento"
                            value={comboModeloNuevoAsiento}
                            onChange={(event) => {
                                const indice = event.target.selectedIndex;
                                const opcion = event.target.options[indice].value;
                                this.cambiarOpcionCombo("comboModeloNuevoAsiento", opcion)
                            }}
                        >
                            <option hidden value="">Seleccione...</option>
                            {modelosManuales.map((modelo) => (
                                <option key={modelo.Id} value={modelo.Id}>
                                    {modelo.Descripcion}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="seccionDatosGenerales__labelDiasDiferimiento AsientosContables__modalNuevoAsiento__descripcionSelectModelo">Sólo se listan modelos donde todos sus renglones sean manuales</div>
                </div>

                <div className="AsientosContables--floatLeft">
                    <InputFecha 
                        titulo={"Fecha valor contable"} 
                        classContenedor={"AsientosContables__contenedorInputFecha"} 
                        value={selectorFechaNuevoAsiento}
                        validarSelectorFecha={validarSelectorFecha}
                    />
                </div>
            </div>
        );
    }
}

export default SeccionSuperior;